import clsx from "clsx"
import PropTypes from "prop-types"
import { Controller, useFormContext } from "react-hook-form"
import NewThumbnailUpload from "~/components/Common/NewThumbnailUpload"

const UploadImage = ({ label, id, className, noCrop }) => {
  const { control } = useFormContext()
  return (
    <Controller
      control={control}
      name={id}
      render={({
        field: { value, onChange, onBlur },
        fieldState: { error },
      }) => (
        <div
          className={clsx(
            "flex flex-col relative mb-4 w-full",
            className && className,
          )}
        >
          <div className="flex justify-between items-center">
            <p className="mt-4 mb-2 text-xs text-brand-secondary font-semibold">
              {label}
            </p>
          </div>
          <NewThumbnailUpload
            noCrop={noCrop ?? false}
            className="h-full"
            title="Drop doc cover image here"
            cloudinaryUploadPreset={
              import.meta.env.VITE_CLOUDINARY_CLOUD_THUMBNAIL_UPLOAD
            }
            value={value ? value : ""}
            onUpload={(res, setLoading) => {
              onChange(res.data)
              setLoading(false)
            }}
            onDelete={() => {
              onChange({})
            }}
          />
          {error && (
            <p className="text-xs text-red-500 absolute -bottom-5">
              {error?.message}
            </p>
          )}
        </div>
      )}
    />
  )
}

UploadImage.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  noCrop: PropTypes.bool,
}

export default UploadImage
